<template>
    <div class="ProposalReview">
        <v-container fluid class="pt-lg-0">
            <v-row>
                <v-col cols="12">
                    <v-row align="center" justify="center">
                        <v-card max-width="1200" :min-width=min_width flat class="pt-lg-0">
                            <v-col cols="12" class="pb-0 pt-lg-0">
                                <v-container class="pb-0 pt-lg-0">
                                    <v-row>
                                        <v-col cols="12" class="pt-lg-0">
                                            <div class="text-h3 font-weight-light primary--text text-center">
                                                Proposal - Review Information
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-col>
                        </v-card>
                        <v-card max-width="1500" :min-width=min_width outlined class="rounded-card">
                            <v-card-text>
                                <v-card v-if="showCurrentCredits">
                                    <v-card-title class="primary section-title">
                                        <div class="white--text text-h5 font-weight-regular">Record Keeping Credits
                                        </div>
                                    </v-card-title>
                                    <v-card-text>
                                        <div class="pa-4 mt-3 text-h6" v-for="vm in proposalViewModels" :key="vm.id">
                                            {{ vm.packet.rk_name }}
                                            <span :class="mobile ? '' : 'float-right'">
                                                <PropRecordKeepingCredit :viewModel="vm" />
                                            </span>
                                            <v-divider></v-divider>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-card-text>
                        </v-card>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PropRecordKeepingCredit from '@/components/proposalcomps/PropRecordKeepingCredit.vue';

export default {
    components: {
        PropRecordKeepingCredit,
    },

    data: () => ({
        showProposals: false,
        showComponent: false,
        showComplete: false,
        panels: [0, 1],
        emailRecipients: [],
        plan_runner: {},
        on: null,
        chromeExtensionPort: undefined,
        // proposalViewModels: undefined,
        showCurrentCredits: false,
        savedPricingTable: undefined
    }),

    props: {
        updateMode: [Boolean],
        proposalContext: [Object],
        duration: [Number],
    },

    watch: {
        'proposalViewModels': {
            deep: true,
            async handler() {
                try {
                    const extensionId = process.env.VUE_APP_EXTENSION_ID || "";
                    if (extensionId) {
                        this.chromeExtensionPort.postMessage({ action: "overrideCreditsUpdated", data: this.proposalViewModels })
                    }
                    // this.debouncedFetch(...args)
                } catch (error) {
                    console.log("error loading ")
                }
                // this.loadingTablePresetCalculations = false
            },
        },

    },

    async mounted() {
        window.scrollTo(0, 0)
        const extensionId = process.env.VUE_APP_EXTENSION_ID || "";
        if (extensionId) {
            this.chromeExtensionPort = await window.chrome.runtime.connect(extensionId, { name: "port-override-credits" });
        }
        this.chromeExtensionPort.onMessage.addListener((message) => {
            if (message.action === "updateProposalViewModel") {
                this.updateProposalViewModels(JSON.parse(JSON.stringify(message.data.proposalViewModels)))

                this.updatePlanOpportunityModel(JSON.parse(JSON.stringify(message.data.planOpportunityViewmodel)))
                this.savedPricingTable = message.data.pricingTable
                this.updateTablePreset(JSON.parse(JSON.stringify(message.data.pricingTable)))
                this.showCurrentCredits = true
            } else if (message.action == "hideOverrideCredits") {
                this.showCurrentCredits = false
            }else if (message.action == "disableOverrideCredits") {
                this.setPdfGenerated(true)
            }
        });
    },

    computed: {
        ...mapGetters({
            proposalViewModels: 'getProposalViewModels',
            planOpportunityViewmodel: 'getplanOpportunityViewmodel',
            pricingTable: "getTablePresetItems",
            planTypeSection: 'getPlanTypeSection',
            savedProposals: 'getSavedProposals',
        }),

        showCredits() {
            return this.planTypeSection.ParentType != 'Cash Balance Only' && !this.planTypeSection.IsNoRevenueShare;
        },


        min_width() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 200;
                case 'sm': return 400;
                case 'md': return 800;
                case 'lg': return 800;
                case 'xl': return 1200;
            }
            return null
        },

        mobile() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return true;
                case 'sm': return true;
                case 'md': return false;
                case 'lg': return false;
                case 'xl': return false;
            }
            return null
        },
    },

    methods: {
        ...mapActions([
            'clearProposalViewModels',
            'saveProposalViewModels',
            'setIsUpdate',
            'checkQueue',
            'downloadProposalPDF',
            'setPdfGenerated',
            'saveProposals',
            'sendEmail',
            'getOtherUserObject',
            'getProposalList',
            'deleteAllsavedProposal',
            'deleteProposalFromList',
            'updateTablePreset',
            'updatePlanOpportunityModel',
            'updateProposalViewModels'
        ]),

        backToBuilder() {
            console.log(`backToBuilder`)
            this.setIsUpdate(false);
            this.clearProposalViewModels();
            this.$emit('return', 'Builder');
        },

        isPricingTable() {
            let isPricingTable = false
            if (this.proposalViewModels && this.proposalViewModels.length > 0) {
                this.proposalViewModels.forEach(v => {
                    if (v.packet?.proposal?.proposal_id == this.id && v.packet.is_html_template)
                        isPricingTable = true
                })
            }
            return isPricingTable
        },

        submit() {
            if (this.mobile) {
                this.$router.push({
                    name: 'dashboard',
                })
            } else {
                this.$emit('return', 'List');
            }
        },
    }
};
</script>

<style type="text/css" scoped>
.section-title {
    bottom-right-border-radius: 0;
    bottom-left-border-radius: 0;
}

.theme--light.v-sheet--outlined {
    border: thin solid rgb(0, 0, 0, 30%);
}

.rounded-card {
    border-radius: 20px !important;
}
</style>